<div class="form-group mb-3">
  <div class="typeahead">
    <vw-text-box
      [id]="id"
      [label]="label"
      [labelClass]="labelClass"
      [type]="'text'"
      [clearButton]="clearButton"
      [parentForm]="parentForm"
      [formControlProp]="formControlProp"
      [buttonText]="buttonText"
      (clear$)="clear()"
      (buttonClick$)="buttonClick()"
      [buttonDisabled]="buttonDisabled"
      [placeholder]="placeholder"
      [loading]="loading"
    >
      <ng-content></ng-content>

      <ul typeahead-list class="mt-1" *ngIf="open">
        <ng-container *ngIf="items.length">
          <li
            *ngFor="let item of items"
            (click)="itemSelected(item)"
            class="pointer"
          >
            <ng-template
              [ngTemplateOutlet]="template"
              [ngTemplateOutletContext]="{ item: item }"
            ></ng-template>
          </li>
        </ng-container>

        <li class="pointer" *ngIf="!items.length">
          <span>{{ noMatchesTranslationKey | translate }}</span>
          <span
            *ngIf="!!showMapToggle"
            (click)="openSelectDealerModal()"
            class="pointer show-map d-flex align-items-center mt-3"
          >
            <i class="fal fa-map-marker-alt me-1"></i>
            {{ "carAndDealer.showMap" | translate }}
          </span>
        </li>
      </ul>
    </vw-text-box>
  </div>
</div>
